import { useNavigate } from 'react-router-dom';
/////////////////////////////////////////////////////////////////////
import { CollectionsGroup } from '@/core/interfaces';
import { setActiveCollectionGroup } from '@/core/redux/slices';
import { useCustomDispatch } from '@/core/redux/hooks';

interface CollectionGroupItemProps {
	group: CollectionsGroup;
}

export const CollectionGroupItem: React.FC<CollectionGroupItemProps> = ({
	group,
}) => {
	/*********************
	// #region Hooks
	**********************/
	const navigate = useNavigate();
	const dispatch = useCustomDispatch();

	/*********************
	// #region Functions
	**********************/
	const handleRedirectToCollection = () => {
		dispatch(setActiveCollectionGroup(group.id));
		navigate(`/collections/${group.id}`);
	};

	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="flex flex-col items-center gap-2 mb-3">
				<div
					className=" grid grid-cols-2 grid-rows-2 gap-2 rounded-lg p-2 bg-white bg-opacity-15 border border-white border-opacity-30 w-[150px]"
					onClick={handleRedirectToCollection}
				>
					{group.items.slice(0, 4).map((collection) => (
						<div
							key={collection.id}
							className="grid grid-rows-3 grid-cols-3 justify-center w-[60px] h-[60px]"
						>
							{collection.stickers.map((sticker, index) => (
								<img
									key={sticker.position.toString()}
									className={`mx-auto h-[20px] w-[20px] border-none ${
										index === 0
											? 'rounded-tl-lg'
											: index === 2
											? 'rounded-tr-lg'
											: index === 6
											? 'rounded-bl-lg'
											: index === 8
											? 'rounded-br-lg'
											: ''
									}`}
									src={sticker.image}
									alt={sticker.position.toString()}
								/>
							))}
						</div>
					))}
				</div>
				<p className="text-center">{group.name}</p>
			</div>
		</>
	);
};
